import React, { useState } from 'react';

import { AddOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';

import ChooseTemplateDialog from './ChooseTemplateDialog';

export default function CreateTemplateButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        size="small"
        variant="contained"
        color="primary"
        onClick={() => setOpen(true)}
        startIcon={<AddOutlined />}
      >
        New
      </Button>
      <ChooseTemplateDialog open={open} close={() => setOpen(false)} />
    </>
  );
}
